/** Layout compartilhado das páginas /clients/new e /clients/:id/edit — alinhado ao ClientDetails. */
export const clientFormPageShellSx = {
  width: "100%",
  maxWidth: "none",
  minWidth: 0,
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  height: "calc(100vh - 64px)",
  minHeight: 0,
  overflow: "hidden",
  p: { xs: 2, md: 2.5, lg: 3 },
};

export const clientFormScrollSx = {
  flex: 1,
  minHeight: 0,
  overflow: "auto",
  overflowX: "hidden",
  pb: 1,
};
